import { render, staticRenderFns } from "./LabelsTable.vue?vue&type=template&id=f2925532&scoped=true&"
import script from "./LabelsTable.vue?vue&type=script&lang=js&"
export * from "./LabelsTable.vue?vue&type=script&lang=js&"
import style0 from "./LabelsTable.vue?vue&type=style&index=0&id=f2925532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2925532",
  null
  
)

export default component.exports